import PropTypes from "prop-types";
import { memo } from "react";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { Amount } from "app/components/ui/Amount/Amount";

const SmartDPProductPricingItem = ({
	label,
	amount,
	sign,
	isBold,
	fontSize = TYPOGRAPHY_VARIANTS.REGULAR,
}) => {
	return (
		<div className="sdp-product__pricing-info-item">
			<Typography variant={fontSize} {...{ isBold }}>
				{label}
			</Typography>
			<Amount value={Math.abs(amount)} sign={sign} signIsBold={false} size={fontSize} />
		</div>
	);
};

SmartDPProductPricingItem.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	amount: PropTypes.number.isRequired,
	sign: PropTypes.oneOf(["+", "-"]),
	isBold: PropTypes.bool,
	fontSize: PropTypes.oneOf(Object.values(TYPOGRAPHY_VARIANTS)),
};

export default memo(SmartDPProductPricingItem);
